import { put, takeLatest } from 'redux-saga/effects';
import { PersonalTaskAPI } from 'api/personal-tasks';
import { logger } from 'services';
import { createStart, create, createSuccess, createFailure } from '..';
import { createPersonalTaskSagaAction } from '../actions';
function* createPersonalTaskSaga(action) {
    const { payload } = action;
    try {
        yield put(createStart());
        const data = yield PersonalTaskAPI.createPersonalTask(payload);
        yield put(create(data));
        yield put(createSuccess());
    } catch (error) {
        logger.error('createPersonalTask failed', {
            error
        });
        yield put(createFailure());
    }
}
export function* watchCreatePersonalTaskSaga() {
    yield takeLatest(createPersonalTaskSagaAction.type, createPersonalTaskSaga);
}
